import { render, staticRenderFns } from "./TradeDetail.vue?vue&type=template&id=660e4cd8&"
import script from "./TradeDetail.vue?vue&type=script&lang=js&"
export * from "./TradeDetail.vue?vue&type=script&lang=js&"
import style0 from "./TradeDetail.vue?vue&type=style&index=0&id=660e4cd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports